import React from "react";
import MidBox from "../../components/Boxes/MidBox";
import Button from "../../components/Button";
import {
  Link,
  useSearchParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppTranslation } from "../../i18n/useAppTranslation";


const whitelist = [
  "http://alpha.chainoflegends.com:3000",
  "https://alpha.chainoflegends.com:3000",
  "http://alpha.chainoflegends.com",
  "http://localhost:3000",
  "http://localhost",
  "https://alpha.chainoflegends.com",
];


const Authorize = () => {
  const [searchParameters,] = useSearchParams();
  const appName = searchParameters.get("appName");
  const appUrl = searchParameters.get("appUrl");
  const token = useSelector((state: any) => state.userToken);
  const { t } = useAppTranslation(["auth", "common"]);
  // const navigate = useNavigate();
  const handleAuthorize = () => {
    const target = appUrl?.endsWith("/") ? appUrl : appUrl + "/";
    window.location.href =
      target + `?authorize=true&authorized-token=${encodeURIComponent(token!)}`;
  };

  const handleDeny = () => {
    const target = appUrl?.endsWith("/") ? appUrl : appUrl + "/";
    window.location.href = target + `?authorize=false`;
  };


  const isWhitelisted = whitelist.includes(appUrl || "none");

  if (!isWhitelisted) {
    return (
      <div>
        <MidBox
          modal
          containerClass=""
          noTitle
          style={{ maxWidth: 600 }}
          className="mx-auto"
        >
          <div
            style={{ marginTop: -30, marginBottom: -20 }}
            className="flex-column align-items-center gap-3 d-flex "
          >
            <img
              src="/assets/images/error.png"
              width={"80%"}
              style={{ maxWidth: 200 }}
            />
            <p className="text-center fs-big">
              {t("auth:authorize.errors.notWhitelisted")}
            </p>
            <div className="d-flex">
              <Link to="/">
                <Button className="mt-2" variant="wide-primary">
                  {t("auth:authorize.actions.backToHome")}
                </Button>
              </Link>{" "}
            </div>
          </div>
        </MidBox>
      </div>
    );
  }

  return (
    <div>
      <div className="">
        <MidBox
          modal
          containerClass=""
          noTitle
          style={{ maxWidth: 600 }}
          className="mx-auto"
        >
          <div style={{ marginTop: -30, marginBottom: -20 }}>
            <h2 className="text-center bold mb-4 text-uppercase">
              {t("auth:authorize.title")} <span className="text-info">{appName}</span>
            </h2>
            <p>
              {t("auth:authorize.request.prefix", { appName })}
            </p>
            <ul>
              <li>{t("auth:authorize.permissions.profile")}</li>
              <li>{t("auth:authorize.permissions.stats")}</li>
              <li>{t("auth:authorize.permissions.inventory")}</li>
              <li>{t("auth:authorize.permissions.postUpdates")}</li>
            </ul>
            <p>
              <strong>{t("auth:authorize.note.label")}</strong>{" "}
              {t("auth:authorize.note.body")}
            </p>
            <p>
              {t("auth:authorize.confirm.prefix")}{" "}
              <a
                className="bold"
                target="_blank"
                rel="noreferrer"
                href={appUrl!}
              >
                {appUrl}
              </a>{" "}
              {t("auth:authorize.confirm.suffix")}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <Button
                variant="primary"
                onClick={() => handleAuthorize()}
                className="me-2 bg-100"
              >
                {t("auth:authorize.actions.authorize")}
              </Button>
              <Button
                variant="secondary"
                className="bg-100"
                onClick={handleDeny}
              >
                {t("auth:authorize.actions.deny")}
              </Button>
            </div>
          </div>
        </MidBox>
      </div>
    </div>
  );
};

export default Authorize;
